/* eslint-disable */
import Vue from "vue";

export default {
  install() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      Vue.prototype.$desktopNotify = (title, body, icon = "/favicon.ico") => { };
    } else {
      if (!Notification) {
        Vue.prototype.$toastr("warning", "Desktop notifications not available in your browser.");
      } else {
        if (Notification.permission !== 'granted') {
          Notification.requestPermission().then(permission => {
            console.log("Desktop Notification Permission: ", permission);
          });
        }
      }

      Vue.prototype.$desktopNotify = (title, body, icon = "/favicon.ico") => {
        if (Notification.permission !== 'granted') {
          Notification.requestPermission().then((permission) => {
            console.log("Desktop Notification Permission: ", permission);
          });
        } else {
          new Notification(title, { icon, body });
        }
      };
    }
  }
};
